// Chakra imports
import {Flex, Grid, Image, SimpleGrid, useColorModeValue,} from "@chakra-ui/react";
// assets
// Custom icons
import React, {useEffect, useState} from "react";
import MiniStatistics from "./components/MiniStatistics";
import logoChakra from "../../../assets/logo/logo.png";
import BuiltByDevelopers from "./components/BuiltByDevelopers";
import {BellIcon, RepeatIcon} from "@chakra-ui/icons";
import {fetchDashboardTiles} from "../services";
import {CartIcon} from "../../../components/Icons/Icons";
import BellScheduler from "../../../Scheduler/BellScheduler";
import DashboardMessageSlider from "./components/DashboardMessageSlider";

export default function Dashboard() {

    const iconBoxInside = useColorModeValue("white", "white");
    const [tiles, setTiles] = useState([]);
    const [tilesLoading, setTilesLoading] = useState(true);

    useEffect(() => {
        fetchDashboardTileData();
    }, []);

    const fetchDashboardTileData = async () => {

        setTilesLoading(true);
        try {
            const response = await fetchDashboardTiles();
            if (response.status === 200) {
                setTiles(response.data);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setTilesLoading(false);
        }

    }

    return (
        <Flex flexDirection='column' pt={{base: "82px", md: "88px", xl: "75px"}} minW="0">

            <SimpleGrid columns={{base: 1, sm: 2}} spacing={{base: "16px", md: "24px"}}>
                {/*<MiniStatistics*/}
                {/*    title={"School"}*/}
                {/*    amount={tiles?.totalSchool}*/}
                {/*    // percentage={55}*/}
                {/*    icon={<BellIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}*/}
                {/*/>*/}
                <MiniStatistics
                    title={"Tota Bell"}
                    amount={tiles?.totalBellMusic}
                    // percentage={5}
                    isLoading={tilesLoading}
                    icon={<RepeatIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
            {/*    <MiniStatistics*/}
            {/*    title={"Total Bell"}*/}
            {/*    amount={"Rs." + 50000 + "+"}*/}
            {/*    // percentage={-14}*/}
            {/*    icon={<RepeatIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}*/}
            {/*/>*/}
                <MiniStatistics
                    title={"Bell Played Days"}
                    amount={tiles?.totalBellPlayed || 0}
                    // percentage={8}
                    isLoading={tilesLoading}
                    icon={<CartIcon h={"24px"} w={"24px"} color={iconBoxInside}/>}
                />
            </SimpleGrid>

            {/*<Grid*/}
            {/*    templateColumns={{sm: "1fr", lg: "1.3fr 1.7fr"}}*/}
            {/*    templateRows={{sm: "repeat(2, 1fr)", lg: "1fr"}}*/}
            {/*    gap='24px'*/}
            {/*    mb={{lg: "26px"}}>*/}
            {/*    <ActiveUsers*/}
            {/*        title={"Active Users"}*/}
            {/*        percentage={23}*/}
            {/*        chart={<BarChart/>}*/}
            {/*    />*/}
            {/*    <SalesOverview*/}
            {/*        title={"Sales Overview"}*/}
            {/*        percentage={5}*/}
            {/*        chart={<LineChart/>}*/}
            {/*    />*/}
            {/*</Grid>*/}

            <Grid
                templateColumns={{base: "minmax(0, 1fr)", xl: "minmax(0, 1.8fr) minmax(300px, 1.2fr)"}}
                my={{base: "16px", md: "26px"}}
                gap={{base: "16px", md: "24px"}}>
                <BuiltByDevelopers
                    title={"शिक्षक र विद्यार्थीहरूका लागि\n" +
                        "डिजिटल घण्टी प्रणाली"}
                    name={"तपाईंलाई स्वागत छ!"}
                    description={
                        "शिक्षक र विद्यार्थीहरूका लागि\n" +
                        "डिजिटल घण्टी प्रणाली\n" +
                        "तपाईंलाई स्वागत छ!\n" +
                        "\n" +
                        "रंगहरू, कार्डहरू, समय तालिका, र जटिल सुविधाहरूको पूर्ण विवरण यहाँ उपलब्ध छ।\n" +
                        "प्रयोग गर्न सजिलो, स्मार्ट व्यवस्थापन, र समयमै सूचना।\n" +
                        "\n" +
                        "\"विद्यालयलाई समयमा चलाउने हाम्रो जिम्मेवारी, डिजिटल घण्टी हाम्रो सहायक।\"\n" +
                        "\n" +
                        "शुभ यात्रा!\n" +
                        "डिजिटल घण्टी प्रबंधन प्रणाली"
                    }
                    image={
                        <Image
                            src={logoChakra}
                            alt='chakra image'
                            minWidth={{md: "100px", lg: "auto"}}
                        />
                    }
                />

                <DashboardMessageSlider/>
            </Grid>
            <BellScheduler/>

        </Flex>
    );
}
